import {RenderIf} from "@alanngo/custom-components/dist"
import { Card, Col } from "react-bootstrap"
import { Link } from "react-router-dom"

const LaptopCard = ({ laptop, cpuLogo, gpuLogo, category }) =>
(
    <Col>
        <RenderIf condition={laptop}>
            <Card className="bg-light" style={{}}>
                <Link to={`/laptop/${laptop._id}`}>
                    <Card.Header>
                        <div align="center">
                            <h5>
                                {category}
                                {laptop.name}|
                                <span className="text-success">${laptop.price}</span>
                            </h5>
                        </div>
                    </Card.Header>
                </Link>
                <Card.Body>
                    <Link to={`/laptop/${laptop._id}`} >
                        <Card.Img fluid src={laptop.links.image} />
                    </Link>
                </Card.Body>
                <Card.Footer>
                    <div align="center">
                        {cpuLogo}
                        {gpuLogo}
                    </div>
                </Card.Footer>
            </Card>
        </RenderIf>
    </Col>
)

export default LaptopCard